import React, { createContext, useEffect, useRef, useState } from "react";
import { OrderStatusLabelMap, PriceDetail } from "../../../../models/Order";
import {
	BookingMobiAdressBottom,
	BookingMobiAdressContent,
	BookingMobiAdressImg,
	BookingMobiAdressTop,
	BookingMobiAdressWrap,
	BookingMobiInnerWrap,
	BookingMobiItemWrap,
	BookingMobiTimeContainerWrap,
	BookingMobiTimeWrap,
	BookingMobiTop,
	BookingMobiWrap,
	BookingTableBodyButton,
	BookingTableBodyButtonCancel,
	BookingTableBodyDate,
	BookingTableBodyStauts,
	Separation,
	Width4,
} from "../styled/DesStyled";
import moment from "moment";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";
import useAlertDialog from "../../../hooks/useAlertDialog";
import useCancelOrder from "../hook/CancelOrder";
import { UserRole } from "../../../../models/User";
import useLoadedUser from "../../../hooks/auth/useLoadedUser";
import PermissionGate from "../../../controls/auth/PermissionGate";
import { formatOrderCalendarDate } from "../../../../utils/orderCalendarDate";

export default function BookingMobi(props: {
	val: PriceDetail;
	reload: () => void;
	setIsDialogLoginOpen: (val: boolean) => void;
	setOrderId: (val: number) => void;
}) {
	const [load, setLoad] = useState(false);
	const { user } = useLoadedUser();
	const { openAlertDialog } = useAlertDialog();
	const { doCancelOrder } = useCancelOrder({ reload: props.reload, user: user, setLoad: setLoad });

	const handleUpdateStatusStaff = async (id: number) => {
		openAlertDialog?.(
			AlertType.Confirm,
			"You definitely want to cancel your order?",
			() => {},
			() => doCancelOrder(id || 0),
			undefined,
			{
				declineText: "Cancel",
				acceptText: "Confirm",
			}
		);
	};
	return (
		<BookingMobiWrap>
			<BookingMobiTop>
				<>ID:{props.val.id}</>
				<BookingTableBodyStauts status={props.val?.status}>
					{" "}
					{OrderStatusLabelMap.get(props.val?.status || 0)}
				</BookingTableBodyStauts>
			</BookingMobiTop>
			<BookingMobiAdressWrap>
				<BookingMobiAdressImg src="./static/img/location.png" />
				<BookingMobiAdressContent>
					<BookingMobiAdressTop>{props.val.partner?.name}</BookingMobiAdressTop>
					<BookingMobiAdressBottom>{props.val.partner?.address}</BookingMobiAdressBottom>
				</BookingMobiAdressContent>
			</BookingMobiAdressWrap>
			<BookingMobiInnerWrap>
				<BookingMobiItemWrap>
					<BookingMobiAdressImg src="./static/img/luggage.png" />
					<BookingMobiAdressContent>
						<BookingMobiAdressTop>Bags</BookingMobiAdressTop>
						<BookingMobiAdressBottom>{props.val.quantity} bag</BookingMobiAdressBottom>
					</BookingMobiAdressContent>
				</BookingMobiItemWrap>
				<BookingMobiItemWrap>
					<BookingMobiAdressImg src="./static/img/money.png" />
					<BookingMobiAdressContent>
						<BookingMobiAdressTop>Amount</BookingMobiAdressTop>
						<BookingMobiAdressBottom>{props.val.totalMoney} USD</BookingMobiAdressBottom>
					</BookingMobiAdressContent>
				</BookingMobiItemWrap>
			</BookingMobiInnerWrap>
			<BookingMobiTimeContainerWrap>
				<BookingMobiAdressImg src="./static/img/time.png" />
				<BookingMobiAdressContent>
					<BookingMobiAdressTop>Drop-off & Pick-up Time</BookingMobiAdressTop>
					<BookingMobiTimeWrap>
						<BookingTableBodyDate>
							{props.val.timeInString
								? formatOrderCalendarDate(props.val.timeInString)
								: (props.val.timeIn && formatOrderCalendarDate(props.val?.timeIn)) || ""}
						</BookingTableBodyDate>
						<Width4></Width4>
						<BookingTableBodyDate>
							{props.val.timeOutString
								? formatOrderCalendarDate(props.val.timeOutString)
								: (props.val.timeOut && formatOrderCalendarDate(props.val?.timeOut)) || ""}
						</BookingTableBodyDate>
					</BookingMobiTimeWrap>
				</BookingMobiAdressContent>
			</BookingMobiTimeContainerWrap>
			{user?.role != UserRole.Partner && (
				<>
					<Separation status={props.val?.status}></Separation>
					<PermissionGate permission="orders.cancel">
						<BookingTableBodyButtonCancel>
							<BookingTableBodyButton
								loading={load}
								status={props.val?.status}
								onClick={() => handleUpdateStatusStaff(props.val.id || 0)}>
								{load ? "Loading ..." : "Cancel"}
							</BookingTableBodyButton>
						</BookingTableBodyButtonCancel>
					</PermissionGate>
				</>
			)}
		</BookingMobiWrap>
	);
}
